module.exports = "/assets/3bd0a857b91d0debf118041cee80ffe4.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/YC.png
// module id = 2025
// module chunks = 0